import { createFileRoute } from "@tanstack/react-router";
import { AvailableTimesPage } from "@/features/admin/available-times";

export const Route = createFileRoute("/admin/visits/available-time-slots")({
  component: AvailableTimesPage,
});
